import RogoLogo from "../../assets/images/icon.svg";

export const LoadingComponent = () => {
	return (
		// load assets/images/icon.svg and make it spin
		<img
			id="rogoloader"
			src={RogoLogo}
			alt="Rogo Logo"
			style={{
				animation: "spin 2s linear infinite",
			}}
			height={200}
			width={200}
		/>
	);
};
